import { useState, useRef, useLayoutEffect } from 'react';
import { createConsultantRefund, findConsultantRefund } from '@/API/repositories/consultantRefunds';
import userManager from '@/API/userManager';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { downloadFile } from '@/common/functions/downloadFile';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { renameFile } from '../../ccManagerHours/components/consultantMonth/components/topInfo/components/addDocument/helpers/renameFile';
import moment from 'moment';

const useConsultantRefunds = () => {
	const {  makeRequest } = useRequestsContext();
    const { addMessage } = useMessageQueueContext();

    const [data, setData] = useState([]);
    const [newRefund, setNewRefund] = useState(false);
    const [reason, setReason] = useState(null);
    const [loadingFiles, setLoadingFiles] = useState([]);

    const fileRef = useRef(null);
    const amountRef = useRef(null);

	const currentUserId = userManager.getUser().id;

    const fetchData = async () => {
        const data = await makeRequest(findConsultantRefund.bind(null, currentUserId));

        if (data?.data) {
            setData(data.data);
        }

        if (!data?.data) {
            addMessage('Error while loading refunds', 'error');
        }
    };

    const downloadPdf = async (id) => {
        if (!id) {
            return addMessage('No file to download', 'error');
        }

        const file = {
            stored_document: id,
        }
        
        await downloadFile(file, makeRequest, setLoadingFiles);
    };

    const handleSubmit = async () => {
        const selectedFile = fileRef.current?.files[0];

        if (!selectedFile) {
            return addMessage('No file selected', 'error');
        }

        if (!amountRef.current.value) {
            return addMessage('No amount selected', 'error');
        }

        if (!reason) {
            return addMessage('No reason selected', 'error');
        }

        if (selectedFile.size > 2 * 1024 * 1024) {
            return addMessage('File size is too large', 'error');
        }

        const name = userManager.getUser()?.name
        const surname = userManager.getUser()?.surname
        
        const file = renameFile(
                    selectedFile,
                    `${name}_${surname}_${moment().format('YYYY-MM-DD-HH-mm')}_refund.${selectedFile.type.split('/')[1]}`,
                );

        const formData = new FormData();
        formData.append('file', file);
        formData.append('amount', amountRef.current.value);
        formData.append('reason', reason.value);
        formData.append('consultant', currentUserId);

       const response = await makeRequest(createConsultantRefund.bind(null, formData));

       if (!response?.data) {
            return addMessage('Error while creating refund', 'error');
       }

        addMessage('Refund created successfully', 'success');
        setNewRefund(false);
        fetchData();
    };

	useLayoutEffect(() => {
		fetchData();
	}, []);

	return { 
        data, setData, 
        downloadPdf, 
        newRefund, setNewRefund, 
        amountRef, 
        reason, setReason, 
        fileRef, 
        handleSubmit,
        loadingFiles,
    };
};

export default useConsultantRefunds;